import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { backend, NewLens } from "Backend";
import { schemas, useForm } from "helpers/FormHelpers";
import { FormSelectField, FormTextField } from "helpers/FormHelpersComponents";

import { useAppDispatch } from "redux/hooks";
import { fetchLenses } from "redux/slices/client";
import useSnackbarPromise from "../../helpers/hooks/useSnackbarPromise";
import { LensType } from "generated/graphql";

type NewLensField = "name" | "description" | "lensType";

interface NewLensDialogProps {
  open: boolean;
  close: () => void;
}
const NewLensDialog = ({ open, close }: NewLensDialogProps) => {
  const dispatch = useAppDispatch();
  const snackbarPromise = useSnackbarPromise();
  const form = useForm<NewLensField>(
    {
      isValid: false,
      values: {
        name: "",
        description: "",
        lensType: "bulk",
      },
      touched: {
        name: false,
        description: false,
        lensType: true,
      },
      errors: {
        name: [],
        description: [],
        lensType: [],
      },
    },
    {
      name: schemas.nonEmpty("Name"),
      description: schemas.nonEmpty("Description"),
      lensType: {},
    }
  );
  const formState = form.formStateHandle[0];

  const onSave = () => {
    const newLens: NewLens = {
      ...formState.values,
      primaryLabel: "Product",
      secondaryLabel: "Injury",
      tertiaryLabel: "Other",
    };
    snackbarPromise(backend.createLens(newLens), {
      successMessage: "Lens created",
      errorMessage: "Unable to create lens",
    }).then(() => {
      dispatch(fetchLenses());
      close();
    });
  };
  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>New Lens</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          "& .MuiTextField-root,.MuiFormControl-root,.MuiFormControlLabel-root": { m: 1 },
        }}>
        <FormTextField label="Name" id="name" useForm={form} />
        <FormTextField label="Description" id="description" useForm={form} />
        <FormSelectField<NewLensField, LensType>
          label="Lens Type"
          id="lensType"
          options={[LensType.Bulk, LensType.Single]}
          useForm={form}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="default">
          Cancel
        </Button>
        <Button variant="contained" color="default" disabled={!formState.isValid} onClick={onSave}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewLensDialog;
